import { LastKmsTransportEnum } from '@repo/utils'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { CarbonFootprintMealTypeFieldProps } from '../CarbonFootprintForm'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../../shadcn/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../shadcn/components/ui/select'

const CarbonFootprintEndOfJourneyField = ({
  form,
}: CarbonFootprintMealTypeFieldProps) => {
  return (
    <FormField
      control={form.control}
      name='endOfJourney'
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel className='font-normal'>
            <FormattedMessage
              id='ui.CarbonFootprintEndOfJourneyField.label'
              defaultMessage='Fin de trajet (derniers kms)'
            />
          </FormLabel>
          <FormControl>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <SelectTrigger error={fieldState.error}>
                <SelectValue
                  placeholder={
                    <FormattedMessage
                      id='ui.CarbonFootprintEndOfJourneyField.placeholder'
                      defaultMessage='Sélectionnez'
                    />
                  }
                />
              </SelectTrigger>
              <SelectContent>
                {endOfJourneyOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      rules={{ required: true }}
    />
  )
}

export default CarbonFootprintEndOfJourneyField

const endOfJourneyOptions = [
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintEndOfJourneyField.option.thermalCar'
        defaultMessage='Voiture thermique'
      />
    ),
    value: LastKmsTransportEnum.THERMAL_CAR,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintEndOfJourneyField.option.electricCar'
        defaultMessage='Voiture électrique'
      />
    ),
    value: LastKmsTransportEnum.ELECTRIC_CAR,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintEndOfJourneyField.option.bus'
        defaultMessage='Bus'
      />
    ),
    value: LastKmsTransportEnum.BUS,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintEndOfJourneyField.option.foot'
        defaultMessage='A pied'
      />
    ),
    value: LastKmsTransportEnum.FOOT,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintEndOfJourneyField.option.none'
        defaultMessage='Aucun'
      />
    ),
    value: LastKmsTransportEnum.NONE,
  },
]
